import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export enum ClinicNotificationLevel {
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

interface ClinicNotification {
  clinicNotificationId: number;
  level: ClinicNotificationLevel;
  message: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  active: boolean;
}

interface ClinicNotificationsResponse {
  notifications: ClinicNotification[];
}

export const useClinicNotifications = () => {
  return useApi<ClinicNotificationsResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<ClinicNotificationsResponse>(
          "/clinic/clinic-notifications/",
        );
        return response.data;
      },
      queryKey: QueryKeys.Clinic.Notifications.DEFAULT,
      enabled: true,
      refetchInterval: 1000 * 10,
      refetchIntervalInBackground: true,
    },
  });
};
